import { PressReleaseItem } from '@oresundsbron/api/src/backend/PressRelease';
import { person } from '@oresundsbron/validators';
import { format } from 'date-fns';
import { z } from 'zod';
import { MetadataItem } from '~/lib/metadata';

export const pressLanguages = ['sv', 'da'];

export const formatDateYear = (
  yearMonth: string,
  locale?: Locale,
  type: string = 'MMMM'
) => format(new Date(yearMonth), type, { locale });

export type PersonType = z.output<typeof person>;

export const createSeoMetaData = (
  path: string,
  singleNewsInfo?: PressReleaseItem
): MetadataItem[] => {
  const mainImage = singleNewsInfo?.mainImage || singleNewsInfo?.images?.[0];

  return [
    {
      name: 'seo-description',
      content: singleNewsInfo?.leadtext || '',
    },
    {
      name: 'og:image',
      content: mainImage?.url || '',
    },
    {
      name: 'og:image:alt',
      content: mainImage?.altText || '',
    },
    {
      name: 'og:type',
      content: 'article',
    },
    { name: 'seo-title', content: singleNewsInfo?.title || '' },
    {
      name: 'og:url',
      content: `${path}`,
    },
  ];
};

export const cropNewsFeedImage = (
  width: number,
  height: number,
  imageUrl?: string | null
) =>
  imageUrl?.replace(/\.(?=[^.]*$)/, `-w_${width}_h_${height}.`) ||
  '/images/press-no-image.jpg';
